import React, { useState, useEffect } from 'react'
import TrainingDay from './TrainingDay'
import axios from 'axios'
import { BiError } from "react-icons/bi";
import { IconContext } from "react-icons";
import { useNavigate, useParams } from 'react-router-dom';
import ModalInfoTrainingDay from './ModalInfoTrainingDay';
import Package from './Package';
import CoursePackBox from './CoursePackBox';
import Select from 'react-select';
const GET_URL = 'dashboard/member/open_qualification_day_register_and_package'

const ModalMyTrainingDays = ({ setModalIsOpen,handleColse, corseId ,getTrainingDaysMain}) => {
    // const { corseId } = useParams();
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [fetchData, setFetchData] = useState([])
    const [show, setShow] = useState(false)
    const [selectedArea, setSelectedArea] = useState(null)
    const [selectedMonth, setSelectedMonth] = useState(null)
    const AREA_OPTIONS = [
        { value: null, label: 'כל האזורים' },
        { value: 'צפון', label: 'צפון' },
        { value: 'מרכז', label: 'מרכז' },
        { value: 'דרום', label: 'דרום' },
    ]
    const MONTH_OPTIONS = [
        { value: null, label: 'כל החודשים' },
        { value: 1,  label: 'ינואר' },  { value: 2,  label: 'פברואר' },
        { value: 3,  label: 'מרץ' },    { value: 4,  label: 'אפריל' },
        { value: 5,  label: 'מאי' },    { value: 6,  label: 'יוני' },
        { value: 7,  label: 'יולי' },   { value: 8,  label: 'אוגוסט' },
        { value: 9,  label: 'ספטמבר' }, { value: 10, label: 'אוקטובר' },
        { value: 11, label: 'נובמבר' }, { value: 12, label: 'דצמבר' },
    ]
    const selectStyles = {
        control: (base, state) => ({
            ...base,
            borderRadius: '999px',
            borderColor: state.isFocused ? '#0d406b' : '#d1d5db',
            boxShadow: state.isFocused ? '0 0 0 2px #0d406b44' : base.boxShadow,
            paddingInline: '2px', minWidth: '130px', minHeight: '34px', height: '34px',
            cursor: 'pointer', '&:hover': { borderColor: '#0d406b' },
        }),
        valueContainer: (base) => ({ ...base, padding: '0 8px' }),
        indicatorsContainer: (base) => ({ ...base, height: '34px' }),
        dropdownIndicator: (base) => ({ ...base, padding: '0 4px' }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#0d406b' : state.isFocused ? '#e8f0f7' : 'white',
            color: state.isSelected ? 'white' : '#374151',
            textAlign: 'right', fontSize: '14px', padding: '7px 12px', cursor: 'pointer',
        }),
        singleValue: (base) => ({ ...base, color: '#0d406b', fontWeight: 600, fontSize: '14px' }),
        menu: (base) => ({ ...base, borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 16px #0002' }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    }
    const filteredData = fetchData
        .filter(course => !selectedArea || course.area === selectedArea)
        .filter(course => {
            if (!selectedMonth) return true
            const dateStr = course.dateStart_pack
            if (!dateStr) return false
            return new Date(dateStr).getMonth() + 1 === selectedMonth
        })
    const navigator = useNavigate()
    const getTrainingDays = async () => {

        // if (!corseId)
        //     await axios.get(GET_URL, {
        //         // params: {
        //         //     "page": page
        //         //     , "size": perPage,
        //         // }
        //     })
        //         .then(response => {
        //             if (response.status == 200) {
        //                 setFetchData(response?.data)
        //             }
        //         })
        // else
        // {
        await axios.get(GET_URL, {
            params: {
                "qId": corseId
                //     , "size": perPage,
            }
        }).then(response => {
            if (response.status == 200) {
                setFetchData(response?.data)
                setShow(true)
            }
        })
    }


    // }

    useEffect(() => {
        getTrainingDays()
    }, [])
    // useEffect(() => {
    //     getTrainingDays()
    // }, [])
    return (
        <div className={`absolute top-0  h-screen z-10 left-0 flex flex-col items-center  w-full  bg-[#FDFFFC]/50`}
            onClick={() => {
                // handleColse()
            }}>
            <div className='w-full min-h-screen overflow-y-auto flex flex-col items-center py-2'>
                <div className={`bg-white w-3/4  rounded-lg   divide-slate-500 border-0 drop-shadow-2xl shadow-2xl border-emerald-50  `}>
                    <div className='w-full bg-[#0d406b] rounded-t-md flex justify-end border-[#0d406b] border-2 '>
                        <button className='p-1 px-2 m-3 border bg-slate-500 hover:bg-slate-200'
                            onClick={() => {
                                // if(fetchData.length == 0 && corseId)
                                navigator("/registrationTrainingDays")
                                // setModalIsOpen("")
                                handleColse()
                            }} >x</button>
                    </div>
                    <div className='flex justify-end gap-2 px-4 py-3 border-b border-gray-100'>
                        <Select
                            options={MONTH_OPTIONS}
                            value={MONTH_OPTIONS.find(o => o.value === selectedMonth) ?? MONTH_OPTIONS[0]}
                            onChange={(opt) => setSelectedMonth(opt?.value ?? null)}
                            isSearchable={false}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            styles={selectStyles}
                        />
                        <Select
                            options={AREA_OPTIONS}
                            value={AREA_OPTIONS.find(o => o.value === selectedArea) ?? AREA_OPTIONS[0]}
                            onChange={(opt) => setSelectedArea(opt?.value ?? null)}
                            isSearchable={false}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            styles={selectStyles}
                        />
                    </div>
                    {show && fetchData.length == 0 && corseId &&
                        <IconContext.Provider value={{ size: "30px" }} >
                            <div className=' flex justify-center items-center h-32 '>
                                <BiError />
                                <span className='bg-red-500 p-2 rounded-md'>קורס לא קיים</span>
                            </div>
                        </IconContext.Provider>}
                    {!filteredData.length == 0 && filteredData?.map((course,index) =>  { return course?.type=="qul"?<TrainingDay course={course} key={course.id} onOpenModal={() => setSelectedCourse(course)} />:
                <CoursePackBox pack={course} key={course.id} onOpenModal={() => setSelectedCourse(course)}></CoursePackBox>   })}
                    {fetchData.length > 0 && filteredData.length === 0 && (
                        <div className='flex justify-center items-center h-24 text-gray-500 text-sm'>
                            לא נמצאו תוצאות לפי הסינון שנבחר
                        </div>
                    )}

                </div>
            </div>
            {selectedCourse && (
               selectedCourse.type=="qul"? <ModalInfoTrainingDay course={selectedCourse} setModalIsOpen={() => setSelectedCourse(null)} handleColse={handleColse} getTrainingDaysMain={getTrainingDaysMain} />
            :<Package course={selectedCourse}   setModalIsOpen={() => setSelectedCourse(null)} handleColse={handleColse} getTrainingDaysMain={getTrainingDaysMain}></Package>
            )}
        </div>
    )
}

export default ModalMyTrainingDays